<template>
  <div class="about_container">
    <div class="company_rofile">
      <div class="title">公司介绍</div>
      <div class="content">
        <p>
          杭州来布科技有限公司——成立于2017年8月，总部位于杭州。
          专注于数据科学研究，致力于智能数据理论研究和数据流通管控技术研发，为多个行业领域提供产品与解决方案。
        </p>
        <p>
          截至2024年4月，来布科技共申请专利47项，其中申请PCT国际阶段专利1项，PCT进入美国专利1项，美国发明专利1项，国内发明专利32项、实用新型专利9项、外观专利3项。其中16项发明专利、8项实用新型专利、3项外观专利已获授权。
          基于自主专利创新的数据2.0专利技术，已经服务多家高端涉密机构企业，如中广核集团
          、国家电网等。
        </p>
      </div>
    </div>
    <!-- 创始人介绍 -->
    <div class="founder">
      <div class="title">创始人介绍</div>
      <div class="content">
        <img
          class="content-left"
          src="../assets/img/founder.png"
          alt="创始人朱小军"
        />
        <div class="content-right">
          <div class="founder-name">朱小军</div>
          <div class="content-position">创始人、首席数据科学家</div>
          <div class="content-text">
            来布科技创始人朱小军，本科毕业于南航飞行器计算机辅助设计专业，上海交通大学硕士。个人拥有发明专利与职务发明专利超过50项，曾在苹果、飞利浦、惠而浦、柯达等世界500强企业担任重要研发和高层管理职务，有着国际化视野和多元化经营管理理念。2017年创立杭州来布科技有限公司，任董事长，首席数据科学家。
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="contact-us">
      <div class="title">联系我们</div>
      <div class="content">
        <div class="content-left">
          <div id="container" style="width: 672px; height: 412px"></div>
        </div>
        <div class="content-right">
          <div class="name">杭州来布科技有限公司</div>
          <div class="item">
            <i class="el-icon-message"></i
            ><span>商务合作：laibu_market@iclab.ltd</span>
          </div>
          <div class="item">
            <i class="el-icon-message"></i><span>反馈邮箱：info@iclabs.cn</span>
          </div>
          <div class="item">
            <i class="el-icon-phone-outline"></i
            ><span>电话：0571-87066659</span>
          </div>
          <div class="item">
            <i class="el-icon-location-outline"></i
            ><span>地址：杭州市西湖区灵隐街道玉古路172号灵隐人工智能产业基地409室</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  data() {
    return {
      map: null,
    };
  },
  methods: {
    initAMap() {
      AMapLoader.load({
        key: "56d36e265d34e04379abbb1bf503c4cf",
        version: "2.0",
        plugins: [],
      }).then((AMap) => {
        this.map = new AMap.Map("container", {
          zoom: 18, // 初始化地图级别
          center: [120.130519, 30.268647], // 初始化地图中心点位置13373777,3517554
        });
        //创建一个 Marker 实例：
        const marker = new AMap.Marker({
          position: new AMap.LngLat(120.130519, 30.268647), //经纬度对象，也可以是经纬度构成的一维数组
          title: "杭州来布科技有限公司",
        });

        // 自定义点标记内容
        var markerContent = document.createElement("div");
        var markerImg = document.createElement("img");
        markerImg.src = "http://www.iclabs.cn/marker.png";
        markerImg.setAttribute("width", "25px");
        markerImg.setAttribute("height", "25px");
        markerContent.appendChild(markerImg);
        marker.setContent(markerContent);

        //将创建的点标记添加到已有的地图实例：
        this.map.add(marker);
      });
    },
  },
  mounted() {
    this.initAMap();
  },
  beforeDestroy() {
    this.map && this.map.destroy();
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.company_rofile {
  min-height: 540px;
  text-align: center;
  background-image: url("../assets/img/download_bg.png");
  padding-top: 142px;
  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
    margin-bottom: 20px;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
    font-size: 18px;
    color: #666666;
    line-height: 38px;
    text-align: left;
    margin-top: 20px;
  }
}

.founder {
  min-height: 550px;
  text-align: center;
  padding-top: 56px;
  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
    margin-bottom: 20px;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
    display: flex;
    margin-top: 20px;
    .content-left {
      width: 219px;
      height: 294px;
      border-radius: 8px 8px 8px 8px;
      margin-right: 40px;
    }
    .content-right {
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .founder-name {
        font-size: 28px;
        color: #262626;
        line-height: 36px;
      }
      .content-position {
        font-size: 18px;
        color: #262626;
        line-height: 28px;
        margin: 12px 0;
      }
      .content-text {
        font-size: 18px;
        color: #666666;
        line-height: 28px;
      }
    }
  }
}

.contact-us {
  height: 640px;
  text-align: center;
  padding-top: 56px;
  background-color: #fafcff;

  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
    display: flex;
    margin-top: 56px;
    .content-left {
      width: 672px;
      height: 436px;
      background-image: url("../assets/img/map.png");
      margin-top: -8px;
      .amap-container {
        top: 8px;
      }
    }
    .content-right {
      flex: 1;
      height: 412px;
      background: #ffffff;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 90px;
      margin-left: -12px;
      .name {
        font-size: 28px;
        color: #262626;
        line-height: 36px;
        margin-bottom: 40px;
      }
      .item {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #262626;
        line-height: 24px;
        margin-bottom: 24px;
        > i {
          margin-right: 8px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .company_rofile {
    min-height: 710px;
    padding-top: 70px;
    .title {
      font-size: 30px;
    }
    .content {
      width: 90%;
      left: 5%;
      margin-left: 0;
    }
  }
  .founder {
    height: 850px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 30px;
    }
    .content {
      width: 100%;
      left: 0;
      margin-left: 0;
      flex-direction: column;
      margin-top: 40px;
      .content-left {
        width: 70%;
        height: fit-content;
        margin: 0 auto 20px auto;
      }
      .content-right {
        .founder-name,
        .content-position {
          text-align: center;
        }
        .content-text {
          padding: 0 18px;
        }
      }
    }
  }

  .contact-us {
    background-image: url("../assets/img/download_bg.png");
    height: fit-content;
    padding-top: 20px;
    .title {
      font-size: 30px;
    }
    .content {
      width: 100%;
      left: 0;
      margin-left: 0;
      margin-top: 0;
      .content-left {
        display: none;
      }
      .content-right {
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        background: transparent;
        margin: 0;
        padding: 0 18px 10px;

        .name{
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .item{
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>